"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isEqual_1 = __importDefault(require("lodash/isEqual"));
class FovMutate {
    static get match() {
        return (nodeToMatch) => (node) => isEqual_1.default(nodeToMatch, node);
    }
    static get delete() {
        return (parent, node, index) => {
            parent.children.splice(index, 1);
        };
    }
}
exports.FovMutate = FovMutate;
//# sourceMappingURL=fov-mutate.js.map